module.exports = __webpack_public_path__ + "media/images/gallery/oc_on-849bf7d8e7fbb295a7ffe341ee8b977d.gif";